module.exports = __webpack_public_path__ + "22d4c95c8961c976d4df945b3564cd87.woff";


//////////////////
// WEBPACK FOOTER
// ./src/style/fonts/GT-Walsheim-Pro-Bold.woff
// module id = 399
// module chunks = 0